<template>
  <a-form-model-item :prop="prop" :colon="false" :rules="rules" has-feedback>
    <span slot="help" class="text-dark"></span>
    <span slot="label" class="text-dark">{{ label || $t(prop) }}</span>
    <a-input v-model="text" v-bind="$attrs" :type="currentType" size="large">
      <a-icon slot="prefix" :type="icon" style="color: rgba(0,0,0,.25)" />
      <a-icon
        v-if="isPassword"
        slot="suffix"
        :type="isPasswordVisible ? 'eye-invisible' : 'eye'"
        style="cursor: pointer"
        @click="togglePasswordVisibility" />
    </a-input>
  </a-form-model-item>
</template>

<script>
export default {
  name: 'JInput',
  data() {
    return {
      isPasswordVisible: false,
    }
  },
  props: [
    'value',
    'prop',
    'icon',
    'format',
    'label',
    'rules',
  ],
  computed: {
    inputType() {
      return (this.$attrs.type || 'text').toLowerCase()
    },
    isPassword() {
      return this.inputType === 'password'
    },
    currentType() {
      if (!this.isPassword) {
        return this.inputType
      }
      return this.isPasswordVisible ? 'text' : 'password'
    },
    text: {
      get() {
        return this.value
      },
      set(value) {
        const formatted = this.format
          ? this.format.format(value)
          : value
        this.$emit('input', formatted)
        this.$emit('change', formatted)
      },
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible
    },
  },
}
</script>
